export const isHtmlElement = <T>(target: T, IO = HTMLElement): boolean => target instanceof IO;
